import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import agentsRoutes from './_agents';
import budgetsRoutes from './_budgets';
import settingsRoutes from './_settings';
import loginRoutes from './_login';
import earningsBenchmarksDashboardRoutes from './_earningsBenchmarksDashboard';
import pvmDashboardRoutes from './_pvmDashboard';
import { isAuthenticated } from '@/stores/authStore';
import unauthenticatedRoutes from './_unauthenticated';
import agreementsRoutes from './_agreements';
import paymentsRoutes from './_payments';
import rosterRoutes from './_roster';
function updateRouteMeta(to: RouteLocationNormalized) {
  const _isAuthenticated = isAuthenticated();
  to.meta.requiresAuth = _isAuthenticated;
  to.meta.layout = _isAuthenticated ? 'LayoutAuthenticated' : 'LayoutDefault';
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: 'TeamBudgets' },
  },
  ...agentsRoutes,
  ...loginRoutes,
  ...agreementsRoutes,
  ...budgetsRoutes,
  ...earningsBenchmarksDashboardRoutes,
  ...pvmDashboardRoutes,
  ...settingsRoutes,
  ...paymentsRoutes,
  ...rosterRoutes,
  ...unauthenticatedRoutes,
  {
    path: '/not-found',
    name: 'NotFound',
    component: () => import('@/views/ErrorIndex.vue'),
    props: { errorType: 'notFound' },
    meta: {
      layout: isAuthenticated() ? 'LayoutAuthenticated' : 'LayoutDefault',
      requiresAuth: isAuthenticated(),
      title: 'pageError.notFound.metaTitle',
    },
    beforeEnter: (to) => updateRouteMeta(to),
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: () => import('@/views/ErrorIndex.vue'),
    props: { errorType: 'noAccess' },
    meta: {
      layout: isAuthenticated() ? 'LayoutAuthenticated' : 'LayoutDefault',
      requiresAuth: isAuthenticated(),
      title: 'pageError.noAccess.metaTitle',
    },
    beforeEnter: (to) => updateRouteMeta(to),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not-found',
  },
];

if (import.meta.env.DEV) {
  routes.push({
    path: '/dev',
    component: () => import('@/views/_DevDemo.vue'),
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'DEV DEMO',
    },
  });
}

export default routes;
